<div class="container-fluid">
  <div class="row fondoAmarillo registro-nav">
    <div class="col-lg-2 col-md-3">
      <img src="assets/img/auri.png" alt="Auri" height="60px">
    </div>
    <div class="col-lg-8 col-md-6 bienvenida">
      <p class="center blanco bold">Auri Graduaciones</p>
    </div>
    <div class="col-lg-2 col-md-3 cerrar-sesion">
      <a class="blanco bold" (click)="cerrarSesion()">Cerrar Sesión</a>
    </div>
  </div>
</div>

<main class="confirmacion-container">
  <section class="confirmacion-card">
    <div *ngIf="verificando">
      <div class="spinner-border text-warning" role="status"><span class="sr-only">Verificando…</span></div>
      <h3>Estamos confirmando tu pago</h3>
      <p>Espera un momento, no cierres esta ventana.</p>
    </div>

    <div *ngIf="confirmado">
      <div class="confirmado-icono" aria-hidden="true">✓</div>
      <h2>¡Pago confirmado!</h2>
      <p>Tu pago fue autenticado y confirmado correctamente.</p>
      <div class="monto-confirmado">
        <span>Cantidad pagada</span>
        <strong>{{montoPagado | currency:moneda:'symbol':'1.2-2'}}</strong>
      </div>
      <button class="btn fondoAmarillo blanco bold" type="button" (click)="irAlPerfil()">Ir a mi perfil</button>
    </div>

    <div *ngIf="error">
      <div class="error-icono" aria-hidden="true">!</div>
      <h3>No pudimos confirmar el pago</h3>
      <p>{{error}}</p>
      <button class="btn btn-outline-secondary" type="button" (click)="volverAlPago()">Volver al pago</button>
    </div>
  </section>
</main>
